import { z } from "zod";

// Unfortunately, z.coerce won't work here, because these are literal strings "true" or "false"
export const rawBooleanlikeSchema = z.object({
  raw: z.literal("false").or(z.literal("true")),
});
